import React from 'react'
import { Stack, Typography, Paper, Skeleton } from '@mui/material'

const Surveys: React.FC = () => {
  return (
    <Stack spacing={3}>
      <Stack spacing={1}>
        <Typography variant="h4" component="h1">
          Surveys
        </Typography>
        <Typography color="text.secondary">
          Monitor hashtag-triggered survey answers with AI grouping, live charts, and manual merge tools.
        </Typography>
      </Stack>
      <Paper variant="outlined" sx={{ p: 3 }}>
        <Skeleton variant="text" width="50%" sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" height={180} sx={{ borderRadius: 2, mb: 2 }} />
        <Skeleton variant="text" width="60%" />
      </Paper>
    </Stack>
  )
}

export default Surveys
